/* Kiwi coined technology marks carry the trademark symbol everywhere they are named
   (Gaurav 2026-09-09). The roster is the live one from State; the names are matched as
   whole words, case as written, and a name that already carries the mark is left alone.
   Runs over text nodes only, never inside scripts, styles, form fields or code, and
   re-runs on DOM changes so Alpine, search results and app blocks get it too.
   window.KiwiTM.text(str) and window.KiwiTM.html(str) are exported for the print system.
   2026-10-11 (speed audit): a change re-walked the whole page. On the home page (8,000 elements,
   carousels and app widgets changing all the time) that cost about 0.6 s of a mid-range phone's
   time. Now only what was added or changed is walked, and a text node is checked against the
   names before its ancestors are looked up. Same marks, same places. */
(function () {
  var NAMES = ['Aferra', 'AirMesh', 'Aramor', 'DexLock', 'DryVault', 'GripTrek', 'GripTREK', 'MorphFit',
    'Noctis 360', 'Nubora', 'Perlyx', 'ScuffShield', 'StormSentry', 'Synapse', 'TriZone', 'Umbra',
    'TerraWeave', 'Veldura', 'YTorq', 'Zephrix'];
  var RE = new RegExp('\\b(' + NAMES.join('|') + ')(?![\\w™®])(?!\\s*™)', 'g');
  // The test copy has no g flag: a global regex keeps lastIndex between test() calls, so testing
  // node after node with RE skipped a name that sat before the previous match's end (2026-09-27).
  var REG = ['Thinsulate'];
  // A ™ already written after one of these (product copy says Thinsulate™) is swapped for ®.
  var RR = new RegExp('\\b(' + REG.join('|') + ')™?(?![\\w®])(?!\\s*®)', 'g');
  var TEST = new RegExp(RE.source + '|' + RR.source);
  var TM = '™';
  // 2026-10-15 (Gaurav): third-party registered marks named in Kiwi copy carry ® the same way (REG, above).
  function text(s) { return s.replace(RE, '$1' + TM).replace(RR, '$1®'); }
  function html(s) {
    return s.replace(/>([^<]+)</g, function (m, t) { return '>' + text(t) + '<'; });
  }
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, TITLE: 1 };
  function walk(root) {
    if (!root || !root.ownerDocument && root.nodeType !== 9) return;
    var doc = root.nodeType === 9 ? root : root.ownerDocument;
    var w = doc.createTreeWalker(root, 4, {
      acceptNode: function (n) {
        if (!TEST.test(n.nodeValue)) return 2;
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || (p.closest && p.closest('[contenteditable], .kiwi-tm-skip, .kwp__data'))) return 2;
        return 1;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) { RE.lastIndex = 0; nodes[i].nodeValue = text(nodes[i].nodeValue); }
  }
  var pending = null, roots = [], full = false;
  function fix(t) {
    var p = t.parentNode;
    if (!p || !TEST.test(t.nodeValue) || SKIP[p.nodeName] || (p.closest && p.closest('[contenteditable], .kiwi-tm-skip, .kwp__data'))) return;
    RE.lastIndex = 0; t.nodeValue = text(t.nodeValue);
  }
  function flush() {
    pending = null;
    var list = roots; roots = [];
    try {
      if (full) { full = false; walk(document.body); return; }
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (!r.isConnected) continue;
        if (r.nodeType === 3) fix(r); else walk(r);
      }
    } catch (e) {}
  }
  function note(n) {
    if (full) return;
    if (roots.length > 300) { full = true; roots = []; return; }
    roots.push(n);
  }
  function start() {
    try { walk(document.body); } catch (e) {}
    try {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var m = ms[i];
          if (m.type === 'characterData') note(m.target);
          else for (var j = 0; j < m.addedNodes.length; j++) { var a = m.addedNodes[j]; if (a.nodeType === 1 || a.nodeType === 3) note(a); }
        }
        if (!pending && (roots.length || full)) pending = setTimeout(flush, 120);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }
  window.KiwiTM = { text: text, html: html, walk: walk, names: NAMES.slice() };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
